import React from 'react';
import PropTypes from 'prop-types';

import globalContextPropTypes from '../shared/propTypes/globalContext';

import EntityFilingDecisions from './entity/filingDecisions/filingDecisions.container';
import ConsolidationFilingDecisions from './consolidation/filingDecisions.container';

/**
 * Note:
 * We fetch all filing decisions for each row at once and load that data onto the grid.
 * When users click on an idividual row we use Print Service to fetch the filing
 * decisions for that specific row as well as to update it.
 */

const FilingDecisions = ({ globalContext, hasUserPermissionsToEdit }) =>
  globalContext.isSeparate ? (
    <EntityFilingDecisions hasUserPermissionsToEdit={hasUserPermissionsToEdit} />
  ) : (
    <ConsolidationFilingDecisions hasUserPermissionsToEdit={hasUserPermissionsToEdit} />
  );

FilingDecisions.propTypes = {
  globalContext: globalContextPropTypes.isRequired,
  hasUserPermissionsToEdit: PropTypes.bool.isRequired,
};

export default FilingDecisions;
